// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 265 ? "ed3608b8" : chunkId) + "." + {"265":"48afbda4bc0786fb","915":"3932f6b4d04b65e0"}[chunkId] + ".js";
};